(function () {
  function init() {
    var root = document.getElementById('lnca-root');
    if (!root) return;

    // ===== CONFIG DESDE EL EDITOR =====
    var PRECIO_NUESTRO   = parseInt(root.getAttribute('data-precio-nuestro') || '200', 10);
    var HUEVOS_MAPLE     = parseInt(root.getAttribute('data-huevos-maple') || '30', 10);
    var PRECIO_SUPER     = parseInt(root.getAttribute('data-precio-super') || '400', 10);
    var NOMBRE_PRODUCTO  = root.getAttribute('data-nombre-producto') || 'maple';
    var HIGHLIGHT_TPL    = root.getAttribute('data-highlight-template') ||
      'Con tu consumo ahorrás {ahorro} {periodo} — equivale a {maples} {nombre_producto}s gratis al año.';

    // Multiplicadores para convertir diario a cada período
    var modeMultiplier = { semana: 7, mes: 30, anio: 365 };
    var modePeriodo    = {
      semana: 'a la semana',
      mes:    'al mes',
      anio:   'al año'
    };

    var mode = 'semana';

    // ===== DOM =====
    var qtySlider   = document.getElementById('lnca-qty');
    var qtyOut      = document.getElementById('lnca-qty-out');
    var superOut    = document.getElementById('lnca-super-out');
    var superTotal  = document.getElementById('lnca-super-total');
    var nuestroTotal= document.getElementById('lnca-nuestro-total');
    var ahorroTotal = document.getElementById('lnca-ahorro-total');
    var barFill     = document.getElementById('lnca-bar-fill');
    var pctEl       = document.getElementById('lnca-pct');
    var highlightEl = document.getElementById('lnca-highlight');
    var modeBtns    = document.querySelectorAll('.lnca-mode-btn');

    // Mostrar precio súper fijo
    superOut.textContent = '$' + PRECIO_SUPER.toLocaleString('es-UY');

    // ===== FORMAT =====
    function fmt(n) {
      return '$' + Math.round(n).toLocaleString('es-UY');
    }

    // ===== RECALCULAR =====
    function recalc() {
      var qtyDiaria = parseInt(qtySlider.value, 10);
      var dias      = modeMultiplier[mode];
      var qtyPeriod = qtyDiaria * dias; // Total de huevos en el período

      // Suffix dinámico: huevos/día → huevos/semana, etc.
      var sufijos = { semana: '/sem', mes: '/mes', anio: '/año' };
      qtyOut.textContent = qtyDiaria + ' ' + (root.getAttribute('data-unidad') || 'huevos') + '/día → ' + Math.round(qtyPeriod) + sufijos[mode];

      var maplesPeriod = qtyPeriod / HUEVOS_MAPLE;

      var costoSuper   = (PRECIO_SUPER / HUEVOS_MAPLE) * qtyPeriod;
      var costoNuestro = (PRECIO_NUESTRO / HUEVOS_MAPLE) * qtyPeriod;
      var ahorro       = Math.max(0, costoSuper - costoNuestro);
      var pct          = costoSuper > 0 ? Math.round((ahorro / costoSuper) * 100) : 0;

      superTotal.textContent  = fmt(costoSuper);
      nuestroTotal.textContent= fmt(costoNuestro);
      ahorroTotal.textContent = fmt(ahorro);
      barFill.style.width     = Math.min(pct, 100) + '%';
      pctEl.textContent       = pct + '%';

      // Highlight
      var ahorroMes     = (ahorro / dias) * 30; // Normalizar a mes para cálculo anual
      var maplesPorAnio = Math.round(((ahorroMes * 12) / PRECIO_NUESTRO));
      
      var texto = HIGHLIGHT_TPL
        .replace('{ahorro}', '<strong>' + fmt(ahorro) + '</strong>')
        .replace('{periodo}', modePeriodo[mode])
        .replace('{maples}', '<strong>' + maplesPorAnio + '</strong>')
        .replace('{nombre_producto}', NOMBRE_PRODUCTO);
      highlightEl.innerHTML = texto;
    }

    // ===== EVENTOS =====
    qtySlider.addEventListener('input', recalc);

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-mode');
        modeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        recalc();
      });
    });

    recalc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();